export default __webpack_public_path__ + "static/media/tunnel6.12ef61df.jpg";